module.exports = __webpack_public_path__ + "static/media/resumeW.571ea826.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/resumeW.svg
// module id = 552
// module chunks = 0